import React, { useRef, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Printer, ArrowLeft, Download } from 'lucide-react';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { getBookingDetails, addBookingDetails, updateBookingDetails, getDockReceipt } from '@/redux/Booking/actions';
import { getAddressAPI } from '@/redux/Purchase/actions';
import {
    getCountryList, getDocumentTypePurchaseList, getDocumentTypeSalesList, getIncoTermsList, getQuantityTypeList, getSalesPersonList, getUomTypeList, getCommodityGroup, getContainerType, GetOperator, getMoveType, GetCurrencyList, GetChargeBasisList, getUomList,
    getFileManagerList, getMasterCompanyDetails
} from "@/redux/Common/actions";
import { callLoader } from '@/redux/Loader/actions';
import { showToast } from '@/redux/Toast/actions';
import { containerRowTemplate, dockReceiptCargoDescription } from './constant';
import { deepClone } from '@/utility/CommonConstant';

function decodeBookingIdParam(encodedId) {
    if (encodedId == null || encodedId === '') return null;
    try {
        return atob(encodedId);
    } catch {
        return encodedId;
    }
}

const DockReceiptPrint = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { countryList, documentTypePurchaseList, documentTypeSalesList, incoTermsList, quantityTypeList, salesPersonList, uomTypeList,
        commodityGroupList, containerTypeList, operatorList, moveTypeList, currency_list, charges_basis_list, MasterCompanyDetails } = useSelector((state) => state.common);

    const { bookingId: encodedId } = useParams();
    const bookingid = decodeBookingIdParam(encodedId);

    const [formData, setFormData] = useState(null);
    const [bookingDetails, setBookingDetails] = useState(null);
    const [chargesByContainer, setChargesByContainer] = useState([]);
    const [containerTypes, setContainerTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const printRef = useRef();
    const [customerAddress, setCustomerAddress] = useState();
    const [authUser] = JSON.parse(localStorage.getItem('authUser') ?? "[{}]");
    // console.log("MasterCompanyDetails", MasterCompanyDetails);
    const mockData = {
        "statuscode": 200,
        "status": "Request processed successfully.",
        "message": "Records retrieved successfully.",
        "data": {
            "totalNum": 0,
            "rowNum": 0,
            "id": 11,
            "companyId": 1,
            "customerId": 101,
            "customerName": "Pa EXPORTS",
            "contactName": "it Sharma",
            "telephone": "9876543210",
            "fax": "123-456-7890",
            "email": "abc@exports.com",
            "operatorId": 10,
            "operatorName": "VISHAL",
            "blModeId": 1,
            "blMode": "SEA",
            "officeTypeId": 2,
            "officeType": "HEAD OFFICE",
            "fileNumber": "SHIPZ01260011",
            "carrierBookingNumber": "CBN12345",
            "customerReference": "REF-555",
            "shippingType": "FCL",
            "salesOrder": "SO-2025",
            "shipment": "Shipment-001",
            "carrierB": "CB-001",
            "invoice": "INV-123",
            "shipperId": 201,
            "shipper": "Global Shippers Pvt Ltd",
            "shipperAddress": "Some Shipper Address",
            "notifyId": 301,
            "notify": "Notify Party Pvt Ltd",
            "notifyAddress": "Notify Address",
            "consigneeId": 401,
            "consignee": "Consignee Pvt Ltd",
            "consigneeAddress": "Consignee Full Address",
            "alsoNotifyId": 501,
            "alsoNotify": "Also Notify Co.",
            "alsoNotifyAddress": "Also Notify Address",
            "carrierMoveType": "CY-CY",
            "ourMoveType": "DOOR-DOOR",
            "ourPlaceOfReceipt": "MUNDRA",
            "carrierPlaceOfReceipt": "MUNDRA",
            "portOfLoading": "MUNDRA PORT",
            "portOfLoadingCode": "INMUN",
            "portOfDischarge": "JEBEL ALI",
            "portOfDischargeCode": "AEJEA",
            "carrierPlaceOfDelivery": "JEBEL ALI",
            "ourPlaceOfDelivery": "DUBAI",
            "countryOfDestination": "UAE",
            "carrier": "MAERSK",
            "carrierCode": "MSK",
            "hodeCarrier": false,
            "carrierContractNumber": "CON-445",
            "vessel": "MV MAERSK SUN",
            "vesselCode": "VSL0011",
            "voyage": "VOY123",
            "voyageCode": "VC123",
            "ourDocCo": "2025-01-01T00:00:00",
            "vgmCo": "2025-01-02T00:00:00",
            "sslDocCo": "2025-01-03T00:00:00",
            "earliestPickupDate": "2025-01-04T00:00:00",
            "earliestRecvdDate": "2025-01-05T00:00:00",
            "autoCo": "2025-01-06T00:00:00",
            "titleCutOff": "2025-01-07T00:00:00",
            "inlandEailCo": "2025-01-08T00:00:00",
            "portCo": "2025-01-09T00:00:00",
            "etsAtOrigin": "2025-01-10T00:00:00",
            "etsAtPol": "2025-01-11T00:00:00",
            "etaAtPod": "2025-01-12T00:00:00",
            "etaAtDestination": "2025-01-13T00:00:00",
            "commodityGroupId": 901,
            "commodityGroup": "GENERAL GOODS",
            "commodity": "ELECTRONICS",
            "hsCodes": "8471",
            "hazCargo": false,
            "hazImoClass": "",
            "hazPkg": "",
            "hazUnNbr": "",
            "weight": 25000.5,
            "weightMetricId": 1,
            "weightMetricType": "KG",
            "clausesType": "STANDARD",
            "documentRequestToCustomer": false,
            "showAutoBoatClause": false,
            "containerCount": 2,
            "containerTypeId": 1,
            "containerType": "40HC",
            "reeferContainerTemperature": 0,
            "tempUom": "",
            "ventStatus": "CLOSED",
            "ventRemark": "",
            "reeferEquipmentAttributes": "",
            "railTrackingRequired": false,
            "paymentModeType": "PREPAID",
            "paymentMode": "CASH",
            "truckerId": 701,
            "trucker": "XYZ Logistics",
            "hideTruckerOnBookingPrint": false,
            "truckerApptConfirmed": true,
            "rateAgreed": "YES",
            "rateAgreedForWaiting": "NO",
            "truckerContainerCount": 2,
            "truckerContainerTypeId": 1,
            "truckerContainerType": "40HC",
            "truckerEmptyContainerPickupId": 801,
            "truckerEmptyContainerPickup": "Pickup Yard",
            "truckerEmptyContainerPickupAddress": "Pickup Address",
            "truckerEarliestPickup": "2025-01-03T00:00:00",
            "truckerEarliestRecvd": "2025-01-04T00:00:00",
            "truckerLatestDeliveryDate": "2025-01-05T00:00:00",
            "truckerContainerReturnToId": 901,
            "truckerContainerReturnTo": "Return Depot",
            "truckerContainerReturnToAddress": "Return Depot Address",
            "cargoDescription": "Electronics & accessories",
            "warehouseInstructionsRemarks": "Handle with care",
            "loadingStatus": "PENDING",
            "liveLoadDate": "2025-01-06T00:00:00",
            "dropDate": "2025-01-07T00:00:00",
            "pickupDate": "2025-01-08T00:00:00",
            "loadingLocationWarehouseId": 1001,
            "loadingLocationWarehouse": "Main Warehouse",
            "loadingLocationWarehouseAddress": "Warehouse Address",
            "loadingLocationWarehouseContactPerson": "Mr. Kumar",
            "loadingLocationWarehouseTelFax": "1234567890",
            "loadingRemarksForTrucker": "Be on time",
            "truckerPoc": "Anil",
            "truckerPhone": "987654321",
            "truckerEmail": "anil@logistics.com",
            "overseasAgentId": 2001,
            "overseasAgent": "Dubai Cargo",
            "overseasAgentAddress": "Dubai Address",
            "overseasAgentRemarks": "Deliver urgently",
            "customerRemarks": "Customer remarks test",
            "internalRemarks": "Internal notes here",
            "sslRemarks": "SSL client remarks",
            "rubberStamp": "STAMPED",
            "createdBy": "SYSTEM",
            "createdOn": "2026-01-13T09:56:32.34",
            "modifiedOn": "2026-01-15T06:00:53.63",
            "modifiedBy": "SYSTEM",
            "isActive": true,
            "loadPlanId": 111,
            "loadPlanNumber": "LP-2025-111",
            "warehouseId": 12,
            "warehouseName": "WarehouseName",
            "warehouseCode": "WarehouseCode",
            "warehouseAddress": "WarehouseAddress",
            "warehouseContact": "WarehouseContact",
            "receivingDate": "2025-01-06T00:00:00",
            "receivingTime": "18:25",
            "appointmentNumber": "gfsd24562345",
            "specialInstructions": "34523452345",
            "letterOfCreditNumber": "LetterOfCreditNumber",
            "lcIssueDate": "2025-01-06T00:00:00",
            "lcExpiryDate": "2025-01-06T00:00:00",
            "insurancePolicyNumber": "InsurancePolicyNumber",
            "insuranceCompany": "InsuranceCompany",
            "additionalNotes": "AdditionalNotes",
            "totalPackageType": 13,
            "packageType": "pallet",
            "rates": [
                {
                    "rateId": 22,
                    "bookingId": 11,
                    "allIn": true,
                    "descriptions": "FREIGHT CHARGES",
                    "currency": "USD",
                    "roe": 83.25,
                    "basis": "PER CONTAINER",
                    "contType": "40HC",
                    "quantity": 2,
                    "sellAmount": 2000,
                    "sellRate": 1000,
                    "vendorId": 3001,
                    "vendorName": "Vendor 1",
                    "chrgBillToPartyId": 4001,
                    "chrgBillToPartyName": "Billing Party 1",
                    "buyAmount": 1800,
                    "buyRate": 900,
                    "paymentMode": "CASH",
                    "descCode": "FRT",
                    "isDeleted": false,
                    "printOnBl": true,
                    "printOnMbl": true,
                    "officeTypeAr": "HO",
                    "officeTypeAp": "HO",
                    "isCustAdditionalRate": 0,
                    "isDisputeAr": false,
                    "isDisputeAp": false,
                    "arPaid": false,
                    "apPaid": false,
                    "inventoryNumber": "INV-1001"
                },
                {
                    "rateId": 23,
                    "bookingId": 11,
                    "allIn": false,
                    "descriptions": "THC CHARGES",
                    "currency": "INR",
                    "roe": 1,
                    "basis": "PER BL",
                    "contType": "",
                    "quantity": 1,
                    "sellAmount": 15000,
                    "sellRate": 15000,
                    "vendorId": 3002,
                    "vendorName": "Vendor 2",
                    "chrgBillToPartyId": 4002,
                    "chrgBillToPartyName": "Billing Party 2",
                    "buyAmount": 14000,
                    "buyRate": 14000,
                    "paymentMode": "CREDIT",
                    "descCode": "THC",
                    "isDeleted": false,
                    "printOnBl": false,
                    "printOnMbl": false,
                    "officeTypeAr": "BRANCH",
                    "officeTypeAp": "BRANCH",
                    "isCustAdditionalRate": 1,
                    "isDisputeAr": false,
                    "isDisputeAp": false,
                    "arPaid": false,
                    "apPaid": false,
                    "inventoryNumber": "INV-1002"
                },
                {
                    "rateId": 24,
                    "bookingId": 11,
                    "allIn": true,
                    "descriptions": "OTHERS - DOCUMENTATION",
                    "currency": "USD",
                    "roe": 83.25,
                    "basis": "PER BL",
                    "contType": "",
                    "quantity": 1,
                    "sellAmount": 50,
                    "sellRate": 50,
                    "vendorId": 3003,
                    "vendorName": "Vendor 3",
                    "chrgBillToPartyId": 4003,
                    "chrgBillToPartyName": "Billing Party 3",
                    "buyAmount": 40,
                    "buyRate": 40,
                    "paymentMode": "CASH",
                    "descCode": "DOC",
                    "isDeleted": false,
                    "printOnBl": true,
                    "printOnMbl": false,
                    "officeTypeAr": "HO",
                    "officeTypeAp": "HO",
                    "isCustAdditionalRate": 0,
                    "isDisputeAr": false,
                    "isDisputeAp": false,
                    "arPaid": false,
                    "apPaid": false,
                    "inventoryNumber": "INV-1003"
                }
            ],
            "transhipmentPorts": [
                {
                    "transPortId": 22,
                    "bookingId": 11,
                    "transPortCity": "china",
                    "transEta": "2025-01-15T00:00:00",
                    "transActualDeparture": "2025-01-16T00:00:00",
                    "transVessel": "MV SEALAND",
                    "transEtd": "2025-01-17T00:00:00",
                    "transVoyage": "SG123",
                    "transActualArrival": "2025-01-18T00:00:00",
                    "isDeleted": false,
                    "createdDate": "2026-01-13T09:56:32.34",
                    "createdBy": "SYSTEM",
                    "modifiedDate": "2026-01-15T06:00:53.63",
                    "modifiedBy": "SYSTEM"
                },
                {
                    "transPortId": 23,
                    "bookingId": 11,
                    "transPortCity": "Usa",
                    "transEta": "2025-01-20T00:00:00",
                    "transActualDeparture": "2025-01-21T00:00:00",
                    "transVessel": "MV PACIFIC",
                    "transEtd": "2025-01-22T00:00:00",
                    "transVoyage": "HK567",
                    "transActualArrival": "2025-01-23T00:00:00",
                    "isDeleted": false,
                    "createdDate": "2026-01-13T09:56:32.34",
                    "createdBy": "SYSTEM",
                    "modifiedDate": "2026-01-15T06:00:53.63",
                    "modifiedBy": "SYSTEM"
                },
                {
                    "transPortId": 24,
                    "bookingId": 11,
                    "transPortCity": "COLOMBO",
                    "transEta": "2025-01-25T00:00:00",
                    "transActualDeparture": "2025-01-26T00:00:00",
                    "transVessel": "MV CEYLON",
                    "transEtd": "2025-01-27T00:00:00",
                    "transVoyage": "COLO100",
                    "transActualArrival": "2025-01-28T00:00:00",
                    "isDeleted": false,
                    "createdDate": "2026-01-13T09:56:32.34",
                    "createdBy": "SYSTEM",
                    "modifiedDate": "2026-01-15T06:00:53.63",
                    "modifiedBy": "SYSTEM"
                }
            ],
            "cargoDimensionDetails": [
                {
                    "cargoDimensionId": 9,
                    "bookingId": 11,
                    "piece": 1,
                    "length": 1,
                    "width": 1,
                    "height": 1,
                    "packageType": "test",
                    "dimensionType": "METER",
                    "cbm": 1,
                    "cft": 35.31,
                    "weightKgs": 1,
                    "weightLbs": 2.2,
                    "createdOn": "2026-01-13T09:56:32.343",
                    "createdBy": "SYSTEM"
                },
                {
                    "cargoDimensionId": 10,
                    "bookingId": 11,
                    "piece": 12,
                    "length": 12,
                    "width": 12,
                    "height": 12,
                    "packageType": "test",
                    "dimensionType": "METER",
                    "cbm": 12,
                    "cft": 352.31,
                    "weightKgs": 12,
                    "weightLbs": 22.2,
                    "createdOn": "2026-01-13T09:56:32.343",
                    "createdBy": "SYSTEM"
                }
            ],
            "clauses": [
                {
                    "id": 1,
                    "bookingId": 11,
                    "clausesTypeDescriptionId": 2,
                    "isActive": true
                },
                {
                    "id": 2,
                    "bookingId": 11,
                    "clausesTypeDescriptionId": 3,
                    "isActive": true
                }
            ]
        }
    };

    const loadCommonData = async () => {
        await dispatch(getMasterCompanyDetails(authUser?.companyId));
        await _getBooking();
        await _getDockReceipt();
    };

    useEffect(() => {
        if (bookingid != null && bookingid !== '') {
            loadCommonData();
        } else {
            setLoading(false);
        }
    }, [bookingid]);

    const _getDockReceipt = async () => {
        try {
            dispatch(callLoader(1));
            const resultData = await dispatch(getDockReceipt(bookingid));
            if (!resultData || typeof resultData !== 'object') {
                dispatch(showToast("No dock receipt data returned.", "error"));
                return;
            }
            console.log("resultData for dock receipt", resultData)
            const next = deepClone(resultData);
            if (!next.dockReceiptContainer?.length) {
                next.dockReceiptContainer = [{ ...containerRowTemplate }];
            }
            if (!next.dockReceiptCargoDescription?.length) {
                next.dockReceiptCargoDescription = dockReceiptCargoDescription;
            }
            setFormData(next);
        } catch (error) {
            dispatch(showToast("Failed to fetch dock receipt.", "error"));
        } finally {
            dispatch(callLoader(0));
            setLoading(false);
        }
    };

    async function _getBooking() {
        try {
            const bookingData = await dispatch(getBookingDetails(bookingid, authUser?.companyId));
            console.log({ bookingData });
            setBookingDetails(bookingData ?? []);
        } catch (error) {
            dispatch(showToast("Failed to load booking details", "error"));
        }
    }

    const _setAddress = async (type, id) => {
        const address = await getAddressAPI(id);

        setCustomerAddress(address);
    };

    const _setNewBooking = async () => {
        if (mockData?.statuscode === 200 && mockData?.data) {
            setFormData(mockData.data);
            processRates(mockData.data);
        } else if (mockData?.data) {
            setFormData(mockData.data);
            processRates(mockData.data);
        }
    };

    const processRates = (data) => {
        if (!data?.rates || !Array.isArray(data.rates)) {
            setContainerTypes([]);
            setChargesByContainer([]);
            return;
        }

        const uniqueContTypes = [
            ...new Set(
                data.rates
                    .filter(rate => rate.contType && rate.contType.trim() !== '')
                    .map(rate => rate.contType)
            )
        ];
        setContainerTypes(uniqueContTypes);

        const chargesGrouped = data.rates.reduce((acc, rate) => {
            const contType = rate.contType?.trim() || "GENERAL";
            if (!acc[contType]) acc[contType] = [];
            acc[contType].push(rate);
            return acc;
        }, {});

        setChargesByContainer(chargesGrouped);
    };

    const handlePrint = () => {
        if (!printRef.current) return;

        const printContent = printRef.current.innerHTML;

        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';

        document.body.appendChild(iframe);

        const win = iframe.contentWindow;
        const iframeDoc = win.document;

        // Copy current app styles so print does not depend on CDN timing.
        const styleTags = Array.from(document.querySelectorAll('style'))
            .map((style) => style.outerHTML)
            .join('');
        const linkTags = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
            .map((link) => link.outerHTML)
            .join('');

        let didPrint = false;
        const runPrint = () => {
            if (didPrint || !iframe.parentNode) return;
            didPrint = true;
            try {
                // Give iframe a little time to paint before opening print dialog.
                window.setTimeout(() => {
                    try {
                        win.focus();
                        win.print();
                    } catch (e) {
                        console.error('Print failed:', e);
                    }
                }, 300);
                win.onafterprint = () => {
                    if (iframe.parentNode) document.body.removeChild(iframe);
                };
            } catch (e) {
                console.error('Print failed:', e);
                if (iframe.parentNode) document.body.removeChild(iframe);
            }
        };

        // Must register before document.write/close — otherwise `load` may fire
        // synchronously and this handler never runs (print dialog never opens).
        iframe.onload = runPrint;

        iframeDoc.open();
        iframeDoc.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Booking - ${formData?.fileNumber || 'Booking'}</title>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            ${linkTags}
            ${styleTags}
            <style>
                @page {
                    size: A4;
                    margin: 15mm;
                }

                body {
                    margin: 0;
                    padding: 0;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
            </style>
        </head>
        <body class="bg-white">
            ${printContent}
        </body>
        </html>
    `);
        iframeDoc.close();

        // Fallback if onload does not fire in some environments
        window.setTimeout(runPrint, 1200);
    };

    const handleDownload = async () => {
        if (!printRef.current || !formData) return;

        try {
            const downloadBtn = document.querySelector('[data-download-btn]');
            const originalText = downloadBtn?.textContent;

            if (downloadBtn) {
                downloadBtn.textContent = 'Generating PDF...';
                downloadBtn.disabled = true;
            }

            const canvas = await html2canvas(printRef.current, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff'
            });

            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = imgWidth / imgHeight;

            let width = pageWidth - 20;
            let height = width / ratio;

            if (height > pageHeight - 20) {
                height = pageHeight - 20;
                width = height * ratio;
            }

            const x = (pageWidth - width) / 2;
            const y = (pageHeight - height) / 2;

            pdf.addImage(imgData, 'PNG', x, y, width, height);
            pdf.save(`Booking_${formData.fileNumber || 'Document'}_${moment().format('YYYY-MM-DD')}.pdf`);

            if (downloadBtn) {
                downloadBtn.textContent = originalText;
                downloadBtn.disabled = false;
            }
        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Failed to generate PDF. Please try printing instead.');
            const downloadBtn = document.querySelector('[data-download-btn]');
            if (downloadBtn) {
                downloadBtn.textContent = 'Download PDF';
                downloadBtn.disabled = false;
            }
        }
    };

    const calculateTotal = (containerType = null) => {
        if (!formData?.rates || !Array.isArray(formData.rates)) return 0;

        if (containerType) {
            return formData.rates
                .filter(rate => rate.contType === containerType)
                .reduce((sum, rate) => sum + (parseFloat(rate.sellAmount) || 0), 0);
        }
        return formData.rates.reduce((sum, rate) => sum + (parseFloat(rate.sellAmount) || 0), 0);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        return moment(dateString).isValid() ? moment(dateString).format('DD MMM YYYY') : '';
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return '';
        return moment(dateString).isValid() ? moment(dateString).format('DD MMM YYYY HH:mm') : '';
    };

    const valueOrDash = (value) => (value != null && String(value).trim() !== '' ? value : '-');
    const receiptNumber = valueOrDash(formData?.drnumber || bookingDetails?.fileNumber);
    const blNumber = valueOrDash(formData?.referencenumber || bookingDetails?.carrierBookingNumber);
    const createdByUser = valueOrDash(formData?.createdby || formData?.createdBy);

    const leftMoreDetails = [
        { label: 'PRE-CARRIAGE BY', value: valueOrDash(bookingDetails?.carrier || bookingDetails?.vessel) },
        { label: 'PLACE OF RECEIPT BY PRE-CARRIER', value: valueOrDash(bookingDetails?.ourPlaceOfReceipt) },
        { label: 'EXPORTING CARRIER', value: valueOrDash(bookingDetails?.carrier) },
        { label: 'PORT OF LOADING/ EXPORT', value: valueOrDash(bookingDetails?.portOfLoading) },
        { label: 'FOREIGN PORT OF UNLOADING (Vessel and air only)', value: valueOrDash(bookingDetails?.portOfDischarge) },
        { label: 'PLACE OF DELIVERY BY ON-CARRIER', value: valueOrDash(bookingDetails?.ourPlaceOfDelivery) },
    ];

    const rightMoreDetails = [
        { label: 'LOADING PIER / TERMINAL', value: valueOrDash(formData?.loadingpierterminal) },
        { label: 'PREPAID/COLLECT', value: valueOrDash(bookingDetails?.paymentModeType) },
        { label: 'TYPE OF MOVE', value: valueOrDash(bookingDetails?.ourMoveType) },
        { label: 'ETA', value: valueOrDash(formatDate(bookingDetails?.etaAtDestination || bookingDetails?.etaAtPod)) },
        { label: 'CONTAINERIZED (Vessel only)', value: valueOrDash(bookingDetails?.shippingType == 'FCL' ? 'Yes' : 'No') },
    ];

    const cargoDescription = formData?.dockReceiptCargoDescription?.[0] || {};
    const cargoRows = formData?.islcManualdetails
        ? [{
            marksAndNumbers: valueOrDash(cargoDescription?.markssealno),
            numberOfPackages: valueOrDash(cargoDescription?.noofpacages),
            description: valueOrDash(cargoDescription?.commoditydescription),
            grossWeight: valueOrDash(cargoDescription?.grossweight),
            measurement: valueOrDash(cargoDescription?.grossmeasurment),
        }]
        : (formData?.dockReceiptContainer || []).map((item) => ({
            marksAndNumbers: `${valueOrDash(item?.containernumber)} / seal: ${valueOrDash(item?.sealnumber)} / ${valueOrDash(item?.marksno)} `,
            numberOfPackages: valueOrDash(item?.nopackage),
            description: ` ${valueOrDash(item?.contype)} / ${valueOrDash(item?.descriptions)}`,
            grossWeight: valueOrDash(item?.kgs),
            measurement: `CBM: ${valueOrDash(item?.cbm)} | CFT: ${valueOrDash(item?.cft)}`,
        }));


    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="text-center">
                    <div className="w-12 h-12 border-4 border-blue-900 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-gray-600">Loading booking data...</p>
                </div>
            </div>
        );
    }

    if (!formData) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="text-center max-w-md px-4">
                    <p className="text-gray-800 font-medium">Could not load dock receipt</p>
                    <p className="text-gray-600 text-sm mt-2">
                        The request finished but no data is available, or the booking ID is invalid.
                    </p>
                    <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="mt-4 px-4 py-2 bg-[#1a2744] text-white rounded-lg text-sm"
                    >
                        Go back
                    </button>
                </div>
            </div>
        );
    }





    return (
        <div className="min-h-screen bg-gray-200 print:bg-white">
            {/* Action Bar */}
            <div className="print:hidden bg-white shadow-sm border-b border-gray-300 sticky top-0 z-10">
                <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-center">
                    {/* <button
                        onClick={onBack}
                        className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all font-medium"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to Booking
                    </button> */}
                    <div className="flex items-center gap-3">
                        <button
                            onClick={handleDownload}
                            data-download-btn
                            className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-all font-medium border border-gray-300"
                        >
                            <Download className="w-4 h-4" />
                            Download PDF
                        </button>
                        <button
                            onClick={handlePrint}
                            className="flex items-center gap-2 px-5 py-2 bg-[#1a2744] hover:bg-[#0f172a] text-white rounded-lg transition-all font-medium"
                        >
                            <Printer className="w-4 h-4" />
                            Print
                        </button>
                    </div>
                </div>
            </div>

            {/* A4 Print Container */}
            <div className="flex justify-center py-6 print:py-0">
                <div ref={printRef} className="a4-page bg-white text-black shadow-xl print:shadow-none p-4">
                    <div className="border border-gray-300 text-[10px] leading-tight">
                        <div className="grid grid-cols-12 border-b border-gray-300 min-h-[54px]">
                            <div className="col-span-3 p-2 flex items-center">
                                <img src={MasterCompanyDetails?.[0]?.CompanyLogoDark} alt={MasterCompanyDetails?.[0]?.CompanyName || "Company Logo"} className="h-8 w-auto" />
                            </div>
                            <div className="dock-title col-span-6 p-2 flex items-center justify-center text-[18px] font-bold text-gray-700 uppercase">
                                Dock Receipt
                            </div>
                            {/* <div className="col-span-3 p-2 flex items-center justify-end text-[14px] font-semibold text-gray-700 text-right">
                                {MasterCompanyDetails?.[0]?.CompanyName || ''}
                            </div> */}
                        </div>

                        <div className="grid grid-cols-12 border-b border-gray-300 min-h-[88px]">
                            <div className="col-span-6 border-r border-gray-300 p-2">
                                <div className="text-[9px] text-gray-500 uppercase mb-1">Exporter <span className="normal-case">(Principal or seller-licensee and address including ZIP Code)</span></div>
                                <div className="font-semibold whitespace-pre-line">{`${valueOrDash(formData?.shipperaddress)}`}</div>
                            </div>
                            <div className="col-span-3 border-r border-gray-300 p-2">
                                <div className="text-[9px] text-gray-500 uppercase"> Document Number</div>
                                <div className="font-semibold mt-1">{receiptNumber}</div>
                                <div className="text-[9px] text-gray-500 uppercase mt-3">Export References</div>
                                <div className="font-semibold mt-1">CUST. REF #: {valueOrDash(bookingDetails?.customerReference)}</div>
                            </div>
                            <div className="col-span-3 p-2">
                                <div className="text-[9px] text-gray-500 uppercase">B/L Number</div>
                                <div className="font-semibold mt-1">{blNumber}</div>
                            </div>
                        </div>

                        <div className="grid grid-cols-12 border-b border-gray-300 min-h-[74px]">
                            <div className="col-span-6 border-r border-gray-300 p-2">
                                <div className="text-[9px] text-gray-500 uppercase mb-1">Consigned To</div>
                                <div className="font-semibold whitespace-pre-line">{`${valueOrDash(formData?.consigneeaddress)}`}</div>
                            </div>
                            <div className="col-span-3 border-r border-gray-300 p-2">
                                <div className="text-[9px] text-gray-500 uppercase mb-1">Forwarding Agent <span className="normal-case">(Name and address - references)</span></div>
                                <div className="font-semibold whitespace-pre-line">{`${valueOrDash(formData?.forwarderaddress)}`}</div>
                            </div>
                            <div className="col-span-3 p-2">
                                <div className="text-[9px] text-gray-500 uppercase">Point (State) of Origin or FTZ Number</div>
                                <div className="font-semibold mt-1">{valueOrDash(formData?.pointforigin)}</div>
                            </div>
                        </div>

                        <div className="grid grid-cols-12 border-b border-gray-300 min-h-[86px]">
                            <div className="col-span-6 border-r border-gray-300 p-2">
                                <div className="text-[9px] text-gray-500 uppercase mb-1">Notify Party / Intermediate Consignee <span className="normal-case">(Name and address)</span></div>
                                <div className="font-semibold whitespace-pre-line">{`${valueOrDash(formData?.notifyaddress)}`}</div>
                            </div>
                            <div className="col-span-6 p-2">
                                <div className="text-[9px] text-gray-500 uppercase mb-1">Domestic Routing / Export Instructions</div>
                                <div className="font-semibold">{valueOrDash(formData?.specialInstructions || formData?.headercommoditydescription)}</div>
                            </div>
                        </div>

                        <div className="grid grid-cols-12 border-b border-gray-300">
                            <div className="col-span-3 border-r border-gray-300 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase">Pre-Carriage By</div>
                                <div className="font-semibold">{valueOrDash(bookingDetails?.carrier || bookingDetails?.vessel)}</div>
                            </div>
                            <div className="col-span-3 border-r border-gray-300 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase">Place of Receipt by Pre-Carrier</div>
                                <div className="font-semibold">{valueOrDash(bookingDetails?.ourPlaceOfReceipt)}</div>
                            </div>
                            <div className="col-span-4 border-r border-gray-300 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase">Loading Pier / Terminal</div>
                                <div className="font-semibold">{valueOrDash(formData?.loadingpierterminal)}</div>
                            </div>
                            {/* <div className="col-span-2 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase">Prepaid/Collect</div>
                                <div className="font-semibold">{valueOrDash(bookingDetails?.paymentModeType)}</div>
                            </div> */}
                        </div>

                        <div className="grid grid-cols-12 border-b border-gray-300">
                            <div className="col-span-3 border-r border-gray-300 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase">Exporting Carrier</div>
                                <div className="font-semibold">{valueOrDash(bookingDetails?.vessel)}</div>
                            </div>
                            <div className="col-span-3 border-r border-gray-300 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase"> Port of Loading / Export</div>
                                <div className="font-semibold">{valueOrDash(bookingDetails?.portOfLoading)}</div>
                            </div>
                            {/* <div className="col-span-3 border-r border-gray-300 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase">Type of Move</div>
                                <div className="font-semibold">{valueOrDash(bookingDetails?.ourMoveType)}</div>
                            </div> */}
                            {/* <div className="col-span-1 border-r border-gray-300 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase">ETA</div>
                                <div className="font-semibold">{valueOrDash(formatDate(bookingDetails?.etaAtDestination || bookingDetails?.etaAtPod))}</div>
                            </div> */}
                            <div className="col-span-2 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase">Containerized <span className="normal-case">(Vessel only)</span></div>
                                <div className="font-semibold">{valueOrDash(bookingDetails?.shippingType == 'FCL' ? 'Yes' : 'No')}</div>
                            </div>
                        </div>

                        <div className="grid grid-cols-12 border-b border-gray-300">
                            <div className="col-span-3 border-r border-gray-300 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase">Foreign Port of Unloading <span className="normal-case">(Vessel and air only)</span></div>
                                <div className="font-semibold">{valueOrDash(bookingDetails?.portOfDischarge)}</div>
                            </div>
                            <div className="col-span-3 border-r border-gray-300 p-1.5">
                                <div className="text-[9px] text-gray-500 uppercase">Place of Delivery by On-Carrier</div>
                                <div className="font-semibold">{valueOrDash(bookingDetails?.ourPlaceOfDelivery)}</div>
                            </div>
                            <div className="col-span-6" />
                        </div>

                        <table className="w-full text-[9px] border-b border-gray-300">
                            <thead>
                                <tr className="text-gray-500 uppercase">
                                    <th className="w-[20%] p-1 border-r border-gray-300">Marks and Numbers</th>
                                    <th className="w-[10%] p-1 border-r border-gray-300">Number of Packages</th>
                                    <th className="w-[43%] p-1 border-r border-gray-300">Description of Commodities</th>
                                    <th className="w-[14%] p-1 border-r border-gray-300">Gross Weight (Kilos)</th>
                                    <th className="w-[13%] p-1">Measurement</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cargoRows.slice(0, 1).map((item, index) => (
                                    <tr key={index} className="h-[250px] align-top">
                                        <td className="p-1 border-r border-gray-300 font-semibold">{item.marksAndNumbers}</td>
                                        <td className="p-1 border-r border-gray-300 text-center font-semibold">{item.numberOfPackages}</td>
                                        <td className="p-1 border-r border-gray-300 font-semibold whitespace-pre-line">{item.description}</td>
                                        <td className="p-1 border-r border-gray-300 text-center font-semibold">{item.grossWeight}</td>
                                        <td className="p-1 text-center font-semibold">{item.measurement}</td>
                                    </tr>
                                ))}
                                <tr className="h-[24px] border-t border-gray-300">
                                    <td className="border-r border-gray-300"></td>
                                    <td className="border-r border-gray-300 text-center font-semibold">TOTAL</td>
                                    <td className="border-r border-gray-300"></td>
                                    <td className="border-r border-gray-300 text-center font-semibold">{formData?.totalkgs}</td>
                                    <td className="border-r border-gray-300 text-center font-semibold">{formData?.totalcbm}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="grid grid-cols-12 min-h-[185px]">
                            <div className="col-span-6 border-r border-gray-300 p-2">
                                <div className="grid grid-cols-3 gap-y-5 text-[9px] text-gray-500 uppercase">
                                    <div>Delivered By</div><div className="col-span-2 font-semibold text-gray-800">{valueOrDash(formData?.loadingLocationWarehouse)}</div>
                                    <div>Lighter Truck</div><div className="col-span-2 font-semibold text-gray-800">{valueOrDash(formData?.loadingStatus)}</div>
                                    <div>Arrived Date</div><div className="font-semibold text-gray-800">{valueOrDash(formatDate(formData?.dropDate))}</div><div className="text-gray-500">Time</div>
                                    <div>Unloaded Date</div><div className="font-semibold text-gray-800">{valueOrDash(formatDate(formData?.truckerEarliestPickup))}</div><div className="text-gray-500">Time</div>
                                    <div>Checked By</div><div className="col-span-2 font-semibold text-gray-800">{valueOrDash(formData?.trucker)}</div>
                                    <div>Placed</div><div className="text-gray-500">In Ship / On Dock</div><div className="text-gray-500">Location</div>
                                </div>
                            </div>
                            <div className="col-span-6 p-2">
                                <p className="text-[10px] text-gray-600 uppercase">
                                    Received the above described goods or packages subject to all the terms of the undersigned's
                                    regular form of dock receipt and bill of lading which shall constitute the contract under
                                    which the goods are received, copies of which are available from the carrier on request and
                                    may be inspected at any of its offices.
                                </p>
                                <div className="text-center text-[9px] text-gray-500 mt-8 uppercase">For the Master</div>
                                <div className="mt-6 text-[9px] text-gray-500 uppercase">By</div>
                                <div className="border-b border-gray-300 h-4"></div>
                                <div className="text-center text-[9px] text-gray-500 uppercase mt-2">Receiving Clerk</div>
                                <div className="mt-5 text-[10px] text-gray-500 uppercase">Date <span className="font-bold text-gray-800 ml-2">{formatDate(formData?.createdon || formData?.createdOn)}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Print Styles */}
            <style>
                {`
                    .a4-page {
                        width: 210mm;
                        min-height: 297mm;
                        box-sizing: border-box;
                        font-size: 10px;
                        background: #ffffff !important;
                        color: #111827 !important;
                    }

                    .a4-page * {
                        color: #111827;
                    }

                    .a4-page .dock-title {
                        color: #38bdf8 !important;
                    }

                    .a4-page img {
                        filter: none !important;
                    }
                    
                    @media screen {
                        .a4-page {
                            margin: 0 auto;
                        }
                    }
                    
                    @media print {
                        @page {
                            size: A4;
                            margin: 10mm;
                        }
                        
                        html, body {
                            width: 210mm;
                            height: 297mm;
                        }
                        
                        body {
                            margin: 0;
                            padding: 0;
                            print-color-adjust: exact;
                            -webkit-print-color-adjust: exact;
                        }
                        
                        .a4-page {
                            width: 100%;
                            min-height: auto;
                            padding: 0;
                            margin: 0;
                            box-shadow: none !important;
                            page-break-inside: avoid;
                            overflow: hidden;
                            background: #ffffff !important;
                            color: #111827 !important;
                        }
                        
                        .print\\:hidden {
                            display: none !important;
                        }
                        
                        .print\\:py-0 {
                            padding-top: 0 !important;
                            padding-bottom: 0 !important;
                        }
                        
                        .print\\:shadow-none {
                            box-shadow: none !important;
                        }
                        
                        .print\\:bg-white {
                            background: white !important;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default DockReceiptPrint;